import { render, staticRenderFns } from "./CategoryModal.vue?vue&type=template&id=3f1c5814&scoped=true&"
import script from "./CategoryModal.vue?vue&type=script&lang=js&"
export * from "./CategoryModal.vue?vue&type=script&lang=js&"
import style0 from "./CategoryModal.vue?vue&type=style&index=0&id=3f1c5814&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f1c5814",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3f1c5814')) {
      api.createRecord('3f1c5814', component.options)
    } else {
      api.reload('3f1c5814', component.options)
    }
    module.hot.accept("./CategoryModal.vue?vue&type=template&id=3f1c5814&scoped=true&", function () {
      api.rerender('3f1c5814', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/references/uniform/modals/CategoryModal.vue"
export default component.exports